/* FN · Collection · Simplified Nutrition
   Goal and format filters, sorting, sticky toolbar, card variant pickers and add to cart. */
(function () {
  'use strict';
  if (window.__fnCol) return;
  window.__fnCol = true;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Sticky offset: sit right under whatever is pinned at the top (sticky header) ---------- */
  function pinnedBottom(exclude) {
    var x = Math.round(window.innerWidth / 2);
    var els = document.elementsFromPoint ? document.elementsFromPoint(x, 1) : [];
    var bottom = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (exclude && exclude.contains(el)) continue;
      var node = el;
      while (node && node !== document.body && node !== document.documentElement) {
        var pos = getComputedStyle(node).position;
        if (pos === 'sticky' || pos === 'fixed') {
          var r = node.getBoundingClientRect();
          if (r.top <= 1 && r.bottom > bottom && r.height < window.innerHeight * 0.5) bottom = r.bottom;
          break;
        }
        node = node.parentElement;
      }
    }
    return Math.max(0, Math.round(bottom));
  }

  function Collection(root) {
    this.root = root;
    this.grid = root.querySelector('[data-fnc-grid]');
    this.bar = root.querySelector('[data-fnc-bar]');
    this.countEl = root.querySelector('[data-fnc-count]');
    this.emptyEl = root.querySelector('[data-fnc-empty]');
    this.sortEl = root.querySelector('[data-fnc-sort]');
    this.formatEl = root.querySelector('[data-fnc-format]');
    this.total = parseInt(root.getAttribute('data-total'), 10) || 0;
    this.state = { goal: [], format: [], sort: 'featured' };
    if (this.grid) {
      this.items = Array.prototype.slice.call(this.grid.querySelectorAll('[data-fnc-item]'));
      this.inserts = Array.prototype.slice.call(this.grid.querySelectorAll('[data-fnc-insert]'));
    } else {
      this.items = [];
      this.inserts = [];
    }
    this.readUrl();
    this.bind();
    this.apply(false);
    this.watchCols();
    this.initSticky();
    this.initCompare();
    this.centerNav();
    this.initChipScroll();
  }

  Collection.prototype.initChipScroll = function () {
    var wrap = this.root.querySelector('[data-fnc-fwrap]');
    if (!wrap) return;
    var row = wrap.querySelector('.fnc-bar__filters');
    var prev = wrap.querySelector('.fnc-scroll--prev');
    var next = wrap.querySelector('.fnc-scroll--next');
    function update() {
      var max = row.scrollWidth - row.clientWidth;
      var hasPrev = row.scrollLeft > 4;
      var hasNext = row.scrollLeft < max - 4;
      wrap.classList.toggle('has-prev', hasPrev);
      wrap.classList.toggle('has-next', hasNext);
      if (prev) prev.hidden = !hasPrev;
      if (next) next.hidden = !hasNext;
    }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fnc-scroll]');
      if (!b) return;
      row.scrollBy({ left: (+b.getAttribute('data-fnc-scroll')) * Math.max(160, row.clientWidth * 0.6), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    update();
  };

  Collection.prototype.centerNav = function () {
    var list = this.root.querySelector('.fnc-nav__list');
    var active = list && list.querySelector('.is-active');
    if (!active || list.scrollWidth <= list.clientWidth) return;
    var li = active.parentElement;
    var left = li.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
    list.scrollLeft = Math.max(0, left - (list.clientWidth - li.offsetWidth) / 2);
  };

  Collection.prototype.readUrl = function () {
    try {
      var q = new URLSearchParams(window.location.search);
      var self = this;
      ['goal', 'format'].forEach(function (k) {
        var v = q.get(k);
        if (!v) return;
        v.split(',').forEach(function (val) {
          var ok = self.root.querySelector('[data-fnc-filter="' + k + '"][data-value="' + val + '"]') ||
            (k === 'format' && self.formatEl && self.formatEl.querySelector('option[value="' + val + '"]'));
          if (ok && self.state[k].indexOf(val) === -1) self.state[k].push(val);
        });
      });
      var s = q.get('sort');
      if (s && this.sortEl && this.sortEl.querySelector('option[value="' + s + '"]')) {
        this.state.sort = s;
        this.sortEl.value = s;
      }
    } catch (e) {}
  };

  Collection.prototype.writeUrl = function () {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      ['goal', 'format'].forEach(function (k) { url.searchParams.delete(k); });
      url.searchParams.delete('sort');
      if (this.state.goal.length) url.searchParams.set('goal', this.state.goal.join(','));
      if (this.state.format.length) url.searchParams.set('format', this.state.format.join(','));
      if (this.state.sort !== 'featured') url.searchParams.set('sort', this.state.sort);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {}
  };

  Collection.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-fnc-filter]');
      if (chip && self.root.contains(chip)) {
        var k = chip.getAttribute('data-fnc-filter');
        var v = chip.getAttribute('data-value');
        var list = self.state[k];
        var at = list.indexOf(v);
        if (at === -1) list.push(v); else list.splice(at, 1);
        self.apply(true);
        return;
      }
      var reset = e.target.closest('[data-fnc-reset]');
      if (reset && self.root.contains(reset)) {
        var scope = reset.getAttribute('data-fnc-reset');
        self.state.goal = [];
        if (scope !== 'goal') self.state.format = [];
        self.apply(true);
        if (reset.closest('[data-fnc-empty]') && self.bar) self.scrollToGrid();
      }
    });
    if (this.formatEl) {
      this.formatEl.addEventListener('change', function () {
        self.state.format = self.formatEl.value ? [self.formatEl.value] : [];
        self.apply(true);
      });
    }
    if (this.sortEl) {
      this.sortEl.addEventListener('change', function () {
        self.state.sort = self.sortEl.value;
        self.apply(true);
      });
    }
    this.root.querySelectorAll('[data-fnc-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var card = sel.closest('.fnc-card');
        var btn = card && card.querySelector('[data-fnc-add]');
        if (btn) btn.setAttribute('data-variant-id', sel.value);
      });
    });
  };

  Collection.prototype.scrollToGrid = function () {
    var top = this.grid.getBoundingClientRect().top + window.pageYOffset - (this.bar ? this.bar.offsetHeight : 0) - pinnedBottom(this.bar) - 12;
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  Collection.prototype.matches = function (item) {
    var g = this.state.goal;
    var f = this.state.format;
    if (g.length) {
      var goals = ' ' + (item.getAttribute('data-goals') || '') + ' ';
      var hit = false;
      for (var i = 0; i < g.length; i++) if (goals.indexOf(' ' + g[i] + ' ') !== -1) { hit = true; break; }
      if (!hit) return false;
    }
    if (f.length && f.indexOf(item.getAttribute('data-format') || '') === -1) return false;
    return true;
  };

  Collection.prototype.sorter = function () {
    var num = function (el, a) { return parseFloat(el.getAttribute(a)) || 0; };
    switch (this.state.sort) {
      case 'rating':
        return function (a, b) { return (num(b, 'data-rating') - num(a, 'data-rating')) || (num(b, 'data-reviews') - num(a, 'data-reviews')) || (num(a, 'data-i') - num(b, 'data-i')); };
      case 'price-asc':
        return function (a, b) { return (num(a, 'data-price') - num(b, 'data-price')) || (num(a, 'data-i') - num(b, 'data-i')); };
      case 'price-desc':
        return function (a, b) { return (num(b, 'data-price') - num(a, 'data-price')) || (num(a, 'data-i') - num(b, 'data-i')); };
      case 'az':
        return function (a, b) { return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || ''); };
      default:
        return function (a, b) { return num(a, 'data-i') - num(b, 'data-i'); };
    }
  };

  Collection.prototype.apply = function (animate) {
    if (!this.grid) return;
    var self = this;
    var filtered = this.state.goal.length > 0 || this.state.format.length > 0;
    var shown = [];
    var hidden = [];
    this.items.forEach(function (it) { (self.matches(it) ? shown : hidden).push(it); });
    shown.sort(this.sorter());

    var showInserts = !filtered && this.state.sort === 'featured';
    var cols = this.cols();
    // Full-row cards snap to the nearest row boundary so the grid never leaves a gap above them.
    this.inserts.forEach(function (el) {
      var pos = +el.getAttribute('data-pos') || 0;
      if (el.getAttribute('data-size') === 'full' && cols > 1) pos = Math.min(shown.length, Math.round(pos / cols) * cols);
      el.__pos = pos;
    });
    var inserts = this.inserts.slice().sort(function (a, b) { return a.__pos - b.__pos; });
    var frag = document.createDocumentFragment();
    var n = 0;
    var ii = 0;
    shown.forEach(function (it, i) {
      while (showInserts && ii < inserts.length && inserts[ii].__pos <= i) {
        inserts[ii].hidden = false; inserts[ii].style.setProperty('--fnc-n', n++); frag.appendChild(inserts[ii]); ii++;
      }
      it.hidden = false;
      it.style.setProperty('--fnc-n', n++);
      frag.appendChild(it);
    });
    while (ii < inserts.length) {
      inserts[ii].hidden = !showInserts;
      if (showInserts) inserts[ii].style.setProperty('--fnc-n', n++);
      frag.appendChild(inserts[ii]); ii++;
    }
    hidden.forEach(function (it) { it.hidden = true; frag.appendChild(it); });
    this.grid.appendChild(frag);

    if (animate && !reduceMotion) {
      this.grid.classList.remove('is-sorting');
      void this.grid.offsetWidth;
      this.grid.classList.add('is-sorting');
      clearTimeout(this._t);
      this._t = setTimeout(function () { self.grid.classList.remove('is-sorting'); }, 900);
    }

    this.root.querySelectorAll('[data-fnc-filter]').forEach(function (chip) {
      var on = self.state[chip.getAttribute('data-fnc-filter')].indexOf(chip.getAttribute('data-value')) !== -1;
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (this.formatEl) this.formatEl.value = this.state.format[0] || '';
    this.root.querySelectorAll('.fnc-chip[data-fnc-reset]').forEach(function (chip) { chip.setAttribute('aria-pressed', self.state.goal.length ? 'false' : 'true'); });

    if (this.countEl) {
      var c = shown.length;
      var txt;
      if (filtered) txt = (this.countEl.getAttribute('data-some') || '[shown] of [count]').replace('[shown]', c).replace('[count]', this.total);
      else txt = (this.total === 1 ? this.countEl.getAttribute('data-one') : this.countEl.getAttribute('data-many') || '[count]').replace('[count]', this.total);
      this.countEl.textContent = txt;
    }
    if (this.emptyEl) this.emptyEl.hidden = shown.length > 0;
    if (animate) this.writeUrl();

    if (animate && this.bar && this.bar.classList.contains('is-stuck')) this.scrollToGrid();
  };

  Collection.prototype.cols = function () {
    if (!this.grid) return 1;
    var t = getComputedStyle(this.grid).gridTemplateColumns || '';
    return t.split(' ').filter(Boolean).length || 1;
  };

  Collection.prototype.watchCols = function () {
    if (!this.inserts.length) return;
    var self = this;
    var last = this.cols();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var c = self.cols();
        if (c !== last) { last = c; self.apply(false); }
      }, 120);
    });
  };

  Collection.prototype.initSticky = function () {
    if (!this.bar) return;
    var self = this;
    var ticking = false;
    function update() {
      ticking = false;
      var top = pinnedBottom(self.bar);
      if (top !== self._top) { self._top = top; self.root.style.setProperty('--fnc-top', top + 'px'); }
      var r = self.bar.getBoundingClientRect();
      self.bar.classList.toggle('is-stuck', r.top <= top + 1 && window.pageYOffset > 10);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  };

  Collection.prototype.initCompare = function () {
    var sc = this.root.querySelector('.fnc-cmp__scroll');
    if (!sc) return;
    sc.addEventListener('scroll', function () { sc.classList.toggle('is-scrolled', sc.scrollLeft > 4); }, { passive: true });
  };

  /* ---------- Add to cart (works with Wonder's cart drawer) ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fn-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && drawer.dataset.cartType === 'drawer' && typeof drawer.renderContents === 'function';
    var html = btn.innerHTML;
    var labelEl = btn.querySelector('span');
    btn.setAttribute('aria-busy', 'true');
    if (labelEl) labelEl.textContent = btn.getAttribute('data-adding') || 'Adding…'; else btn.textContent = btn.getAttribute('data-adding') || 'Adding…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var ok = false;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { toast(res.description || res.message || 'Sorry, this item could not be added.'); return; }
        ok = true;
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fn-collection', productVariantId: id, cartData: res });
        }
        if (btn.closest('.fns-cartx')) { window.location.reload(); return; }
        if (useDrawer && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.classList.remove('wt-cart--empty');
          drawer.renderContents(res, !document.body.classList.contains('page-overlay-cart-on'));
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.innerHTML = html;
        if (ok) {
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        }
      });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fnc-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  function init(scope) {
    (scope || document).querySelectorAll('[data-fnc]').forEach(function (el) {
      if (el.__fnc) return;
      el.__fnc = new Collection(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
